export const autoDetectAffiliateSourceFormatter = (url: string) => {
    if (/^https:\/\/www.amazon.com\//.test(url)) {
        return amazonFormatter();
    }

    return '';
}

export const amazonFormatter = () => {
    return 'amazon';
}